import KycApprovalsAdminPartial from "../../../partials/admin/kyc-approvals/kyc-approvals.admin.partial";

export default function KycApprovalsAdminScreen() {
  return <KycApprovalsAdminPartial />;
}
